/**
 * Converts a Date object to ISO string at UTC midnight
 * Prevents timezone shifts when sending date-only values to API
 * @param date - Date object from form or datepicker
 * @returns ISO string at UTC midnight (YYYY-MM-DDTHH:mm:ss.sssZ) or null
 */
export function adaptTimeForAPI(date: Date | null | undefined|string): string | null {
  if (!date) {
    return null;
  }
  
  // Convert string to Date if needed
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // Check for invalid date
  if (isNaN(dateObj.getTime())) {
    console.warn('Invalid date provided to adaptTimeForAPI:', date);
    return null;
  }
  
  return new Date(Date.UTC(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate()
  )).toISOString();
}